import React from 'react'

import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';

import Dropdown from '../Dropdown/Dropdown';


export default class AccountCard extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
            
        }
    }
    
    componentDidMount=()=>{
        
    }

    render(){
        const {account_id,account_name,account_created,account_closed,status} = this.props
        return <div ref={this.parentRef} style={{display:'flex',height:"7.7vh", width:'auto',flexDirection:'row', backgroundColor:Colors.white,overflow:'visible', border:'1px solid '+Colors.grey, margin:'1vw',borderRadius:5,borderLeft:status?'5px solid rgba(0,215,140,1)':'5px solid rgba(255,0,0,1)'}}>
            <div style={{display:'flex',flexDirection:'row',alignItems:'center', flex:1,overflow:'visible'}}>
                {/* transaction type */}
                <div style={{width:'6vw',marginLeft:'0.5vw'}}><span style={{...Fonts.subtext,fontWeight:600}}>{account_id}</span></div>
                {/* Transaction Date */}
                <div style={{width:'7.5vw'}}><span style={{...Fonts.subtext,fontWeight:600}}>{account_name}</span></div>
                {/* Transaction Provider/account number, service */}
                <div style={{width:'7vw'}}><span style={{...Fonts.subtext,fontWeight:600}}>{account_created}</span></div>
                {/* Transaction Provider/account number, service */}
                <div style={{width:'6vw'}}><span style={{...Fonts.subtext,fontWeight:600}}>{account_closed}</span></div>
                {/* Transaction Provider/account number, service */}
                <div style={{width:'6vw'}}><span style={{...Fonts.subtext,fontWeight:600,color:status?Colors.green:Colors.red}}>{status?'Active':"Inactive"}</span></div>
                <div><Dropdown noBold width='8vw' items={["Transfer Account","Close Account"]} defaultValue={"Select"} onChange={(val)=>{this.setState({contr_year:val})}} />
                </div>
            </div>
        </div>
    }
}